import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { requestJira } from '@forge/bridge';
export var getSuggestions = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(url) {
    var options, response;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          options = {
            method: 'GET',
            headers: {
              'Content-type': 'application/json'
            }
          };
          _context.next = 3;
          return requestJira(url, options);
        case 3:
          response = _context.sent;
          return _context.abrupt("return", response.json());
        case 5:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function getSuggestions(_x) {
    return _ref.apply(this, arguments);
  };
}();